export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./edit.vue?vue&type=template&id=1613b808"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/branches/branch/jackpots/edit.vue?vue&type=template&id=1613b808
// module id = fVOt
// module chunks = 0